import {Inject, Injectable} from "ng-metadata/core";
import {getAuthenticationMethods, getCaptcha} from "../appConfig/appConfigForward";
import {CaptchaService} from "./captcha/captcha.service";
import {ConfigurationUtil} from "../nddUtils/configurationUtil.service";

export enum HandleLimitOffsetErrorResult {
    RETRY,
    USER_LOGGED_IN,
    ERROR
}

@Injectable()
export class RestrictedOffsetHandlerService {

    constructor(
        @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
        @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
        private captchaService: CaptchaService,
        private configurationUtil: ConfigurationUtil
    ) {
    }

    public isRestrictedOffsetError(error: any): boolean {
        const errorData = ('data' in error) ? error.data : error;
        return errorData.errorCode === 401 && errorData.errorMessage === 'Restricted offset for guest users';
    }

    public handleRestrictedOffsetError(): Promise<HandleLimitOffsetErrorResult> {
        if (this.isCaptchaEnabled()) {
            return this.showCaptchaPopup().then(
                () => {
                    return HandleLimitOffsetErrorResult.RETRY;
                }, () => {
                    return HandleLimitOffsetErrorResult.ERROR;
                });
        } else if (this.isLoginAvailable()) {
            const $rootScope = this.$rootScope;
            // Do not call loginService directly because it creates circular dependency
            return new Promise<HandleLimitOffsetErrorResult>((resolve) => {
                $rootScope.$emit('showLoginPopup',
                    () => {
                        resolve(HandleLimitOffsetErrorResult.USER_LOGGED_IN);
                    }, () => {
                        resolve(HandleLimitOffsetErrorResult.ERROR);
                    });
            });
        } else {
            return this.showNoSignInAvailablePopup().then(
                () => {
                    return HandleLimitOffsetErrorResult.ERROR;
                }, () => {
                    return HandleLimitOffsetErrorResult.ERROR;
                });
        }
    }

    private isLoginAvailable(): boolean {
        if (getAuthenticationMethods().length === 0) {
            return false;
        }
        if (this.configurationUtil.getDiscoveryLocalNoLogin() ||
            this.configurationUtil.getDiscoveryServicesPage() ||
            this.configurationUtil.getDiscoveryWithExternalNoLogin()) {
            return false;
        }
        return true;
    }

    private isCaptchaEnabled(): boolean {
        const captchaConfig = getCaptcha();
        return (captchaConfig.isActiveCapcha === 'Y' && !!captchaConfig.public_key);
    }

    private showCaptchaPopup(): Promise<void> {
        const templateString = '' +
            '<md-dialog> ' +
            '<prm-captcha-popup ' +
            '(on-response)="$ctrl.onResponse($event)" ' +
            '></prm-captcha-popup> ' +
            '</md-dialog>';

        const $mdDialog = this.$mdDialog;
        const captchaService = this.captchaService;
        const ret: ng.IPromise<any> = $mdDialog.show({
            template: templateString,
            controller: function () {
                this.onResponse = (response) => {
                    captchaService.validateCaptchaResponse(response, 'limit_offset')
                        .then(() => {
                            $mdDialog.hide();
                        })
                }
            },
            bindToController: true,
            controllerAs: '$ctrl'
        });
        return Promise.resolve(ret);
    }

    public showNoSignInAvailablePopup(): Promise<void> {
        const templateString = '' +
            '<md-dialog>' +
            '<prm-no-sign-in-available-popup>' +
            '</prm-no-sign-in-available-popup> ' +
            '</md-dialog>';

        const ret: ng.IPromise<any> = this.$mdDialog.show({
            template: templateString
        });
        return Promise.resolve(ret);
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/security/restrictedOffsetHandler.service.ts